import { render, staticRenderFns } from "./ProductRemove.vue?vue&type=template&id=98a8fdc0&"
import script from "./ProductRemove.vue?vue&type=script&lang=js&"
export * from "./ProductRemove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDialog,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98a8fdc0')) {
      api.createRecord('98a8fdc0', component.options)
    } else {
      api.reload('98a8fdc0', component.options)
    }
    module.hot.accept("./ProductRemove.vue?vue&type=template&id=98a8fdc0&", function () {
      api.rerender('98a8fdc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ShopSetting/Pages/Warehouse/components/Product/ProductRemove.vue"
export default component.exports